// Mock data for Fitness Influencer Portfolio

export const influencerData = {
  name: "Marcus Steel",
  tagline: "Elite Fitness Influencer",
  title: "Transform Your Brand with",
  highlightWord: "Results-Driven",
  subtitle: "Fitness Marketing",
  description: "Partnering with premium fitness and lifestyle brands to create authentic content that converts followers into customers. 1.4M+ engaged fitness enthusiasts trust my recommendations.",
  stats: {
    followers: "1.4M+",
    monthlyReach: "9.2M",
    engagement: "5.8%",
    usaAudience: "72%"
  },
  email: "collab@marcussteel.com",
  social: {
    instagram: "@marcussteel",
    youtube: "MarcusSteelFitness",
    tiktok: "@marcussteel"
  }
};

export const brandLogos = [
  { name: "Nike", id: 1 },
  { name: "Gymshark", id: 2 },
  { name: "MyProtein", id: 3 },
  { name: "Under Armour", id: 4 },
  { name: "Lululemon", id: 5 },
  { name: "Reebok", id: 6 }
];

export const aboutData = {
  title: "Your Bridge to the Fitness Community",
  description: "With over 7 years in the fitness industry and 1.4M+ followers across platforms, I've built a community that trusts my recommendations. My content doesn't just get views—it drives action.",
  highlights: [
    "7+ years fitness industry experience",
    "Certified Personal Trainer & Nutritionist",
    "50+ successful brand collaborations",
    "Featured in Men's Health & Muscle & Fitness"
  ],
  image: "https://images.unsplash.com/photo-1646938863839-4d49ded55765?w=600&h=800&fit=crop"
};

export const audienceInsights = {
  genderSplit: {
    male: 62,
    female: 38
  },
  ageDistribution: [
    { range: "18-24", percentage: 28 },
    { range: "25-34", percentage: 45 },
    { range: "35-44", percentage: 18 },
    { range: "45+", percentage: 9 }
  ],
  topCities: [
    { city: "Los Angeles", percentage: 18 },
    { city: "New York", percentage: 15 },
    { city: "Miami", percentage: 12 },
    { city: "Chicago", percentage: 9 },
    { city: "Houston", percentage: 7 }
  ]
};

export const performanceMetrics = [
  { label: "Total Followers", value: "1.4M+", icon: "Users" },
  { label: "Monthly Reach", value: "9.2M", icon: "Eye" },
  { label: "Engagement Rate", value: "5.8%", icon: "TrendingUp" },
  { label: "USA Audience", value: "72%", icon: "MapPin" },
  { label: "Avg. Story Views", value: "280K", icon: "PlayCircle" },
  { label: "Avg. Reel Views", value: "1.2M", icon: "Video" }
];

export const contentShowcase = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=400&h=400&fit=crop",
    likes: "42.3K",
    comments: "1.2K",
    type: "reel"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3?w=400&h=400&fit=crop",
    likes: "38.7K",
    comments: "892",
    type: "post"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1604480133080-602261a680df?w=400&h=400&fit=crop",
    likes: "56.1K",
    comments: "2.1K",
    type: "reel"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1758599879792-d6d5d4e3289c?w=400&h=400&fit=crop",
    likes: "29.4K",
    comments: "743",
    type: "post"
  },
  {
    id: 5,
    image: "https://images.pexels.com/photos/31849599/pexels-photo-31849599.jpeg?w=400&h=400&fit=crop",
    likes: "61.8K",
    comments: "1.8K",
    type: "reel"
  },
  {
    id: 6,
    image: "https://images.pexels.com/photos/36120641/pexels-photo-36120641.png?w=400&h=400&fit=crop",
    likes: "33.2K",
    comments: "956",
    type: "post"
  }
];

export const caseStudies = [
  {
    id: 1,
    brand: "Gymshark",
    campaign: "Summer Shred Challenge",
    results: {
      impressions: "4.2M",
      engagement: "8.3%",
      conversions: "12,400",
      roi: "340%"
    },
    description: "Led a 6-week fitness challenge that drove massive engagement and direct sales through exclusive discount codes."
  },
  {
    id: 2,
    brand: "MyProtein",
    campaign: "Protein Launch Campaign",
    results: {
      impressions: "3.8M",
      engagement: "7.1%",
      conversions: "8,900",
      roi: "280%"
    },
    description: "Product launch campaign featuring workout tutorials and recipe content that showcased the new protein line."
  },
  {
    id: 3,
    brand: "Nike Training",
    campaign: "Just Do It Series",
    results: {
      impressions: "6.1M",
      engagement: "9.2%",
      conversions: "15,200",
      roi: "420%"
    },
    description: "Premium brand partnership featuring exclusive Nike gear across a multi-platform content series."
  }
];

export const services = [
  {
    id: 1,
    title: "Sponsored Posts",
    description: "High-quality feed posts featuring your product with authentic storytelling and strong CTAs.",
    icon: "Image",
    price: "From $5,000"
  },
  {
    id: 2,
    title: "Reels & Short-Form",
    description: "Engaging vertical video content optimized for maximum reach and virality.",
    icon: "Video",
    price: "From $7,500"
  },
  {
    id: 3,
    title: "Story Takeovers",
    description: "24-hour story campaigns with swipe-ups, polls, and direct engagement.",
    icon: "Smartphone",
    price: "From $3,000"
  },
  {
    id: 4,
    title: "Brand Ambassador",
    description: "Long-term partnerships with consistent content creation and brand representation.",
    icon: "Award",
    price: "Custom Pricing"
  },
  {
    id: 5,
    title: "UGC Creation",
    description: "Professional user-generated content for your brand's marketing channels.",
    icon: "Camera",
    price: "From $2,500"
  },
  {
    id: 6,
    title: "Event Appearances",
    description: "In-person brand representation at fitness events, expos, and launches.",
    icon: "Calendar",
    price: "From $10,000"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    title: "Brand Manager, Gymshark",
    content: "Marcus delivered exceptional ROI on our summer campaign. His audience engagement is unmatched in the fitness space, and his professionalism made the collaboration seamless.",
    avatar: "SC"
  },
  {
    id: 2,
    name: "David Rodriguez",
    title: "Marketing Director, MyProtein",
    content: "Working with Marcus transformed our product launch. The content quality and conversion rates exceeded all our projections. A true professional.",
    avatar: "DR"
  },
  {
    id: 3,
    name: "Emily Thompson",
    title: "Partnership Lead, Nike",
    content: "Marcus understands how to create content that resonates. His ability to blend authentic fitness content with brand messaging is exactly what premium brands need.",
    avatar: "ET"
  }
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Audience", href: "#audience" },
  { label: "Content", href: "#content" },
  { label: "Results", href: "#results" },
  { label: "Services", href: "#services" }
];
